module.exports = __webpack_public_path__ + "img/icon-navigation-menu.4773058b.svg";